var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash 1",
    clipPath: "url(#clip0_97_1315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5001 2.75C11.5001 2.33579 11.1643 2 10.7501 2H8.86207C8.54613 1.10368 7.70044 0.503047 6.75007 0.5H5.25007C4.2997 0.503047 3.45401 1.10368 3.13807 2H1.25006C0.83585 2 0.500061 2.33579 0.500061 2.75C0.500061 3.16421 0.83585 3.5 1.25006 3.5H1.50007V9.75001C1.50007 11.2688 2.73129 12.5 4.25006 12.5H7.75005C9.26885 12.5 10.5001 11.2688 10.5001 9.75001V3.5H10.7501C11.1643 3.5 11.5001 3.16421 11.5001 2.75ZM9.00007 9.75001C9.00007 10.4404 8.44043 11 7.75008 11H4.25006C3.55971 11 3.00007 10.4404 3.00007 9.75001V3.5H9.00007V9.75001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.75009 9.5C5.1643 9.5 5.50009 9.16421 5.50009 8.75V5.75C5.50009 5.33579 5.1643 5 4.75009 5C4.33588 5 4.00009 5.33579 4.00009 5.75V8.75C4.00009 9.16421 4.33588 9.5 4.75009 9.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.25006 9.5C7.66427 9.5 8.00006 9.16421 8.00006 8.75V5.75C8.00006 5.33579 7.66427 5 7.25006 5C6.83585 5 6.50006 5.33579 6.50006 5.75V8.75C6.50006 9.16421 6.83585 9.5 7.25006 9.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_1315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6.10352e-05 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.658c7ba8dae710808926caece2353d07.svg";
export { ForwardRef as ReactComponent };